import { initItemPage } from 'src/lib/item-page.js'
import 'src/styles/classification_viewer.css'

initItemPage()
